import React, { useContext } from 'react';

import BuildingContext from '@totem/components/portfolio/buildings/details/container/BuildingContext';
import { isNotNull } from '@totem/utilities/common';

const BuildingDetailPageTitle = () => {
  const { data } = useContext(BuildingContext);

  return <span>{isNotNull(data) ? data.building.name : ''}</span>;
};

export default BuildingDetailPageTitle;
